import { render, staticRenderFns } from "./ObiDropdownItem.vue?vue&type=template&id=14ba6392&scoped=true&"
import script from "./ObiDropdownItem.vue?vue&type=script&lang=js&"
export * from "./ObiDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./ObiDropdownItem.vue?vue&type=style&index=0&id=14ba6392&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ba6392",
  null
  
)

export default component.exports